export default __webpack_public_path__ + "static/media/profile.8c47e257.jpg";